import {
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { LogOut } from "lucide-react";

interface ILogoutModalProps {
  /** "controlled": não renderiza gatilho — quem abre é o pai (GEN-3497, menu de conta da navbar). */
  st: "complete" | "simple" | "controlled";
  isOpen?: boolean;
  onClose?: () => void;
}

export const LogoutModal = (props: ILogoutModalProps) => {
  // useDisclosure em modo controlado quando o pai passa isOpen; caso contrário, interno
  // (como sempre foi para os gatilhos da sidebar).
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { isOpen, onOpen, onClose } = useDisclosure({ isOpen: props.isOpen, onClose: props.onClose });

  return (
    <>
      {props.st === "controlled" ? null : props.st === "complete" ? (
        <Flex gap="8px" alignItems="center" onClick={onOpen} _hover={{ cursor: "pointer" }}>
          <LogOut color="#ffffffd1" width="22px" height="22px" />
          <Text fontSize="12px">Sair</Text>
        </Flex>
      ) : (
        <Tooltip label="Sair da Conta">
          <Flex justifyContent="center" onClick={onOpen} _hover={{ cursor: "pointer" }}>
            <LogOut color="#ffffffd1" width="22px" height="22px" />
          </Flex>
        </Tooltip>
      )}

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose} size="sm">
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" alignItems="center" />
        <ModalContent flexGrow={1} flexShrink={1} borderLeft="12px solid #0263FF" borderRadius={8}>
          <ModalHeader>Sair da Conta</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent="center" flexDirection="column" gap={5}>
              Deseja sair de sua conta?
              <Flex gap={2} flexGrow={1} justifyContent="space-between">
                {/* Full page load: sair via rota SPA deixava o app preso em /logout
                    com a sessão viva; o load completo espelha o caminho do 401
                    (/logout?expired=1), que limpa o token de forma confiável. */}
                <Button
                  fontSize={12}
                  width="50%"
                  bg="#4B4EFF"
                  onClick={() => window.location.assign("/logout")}
                  color="white"
                  _hover={{ bgColor: "#BABBFF", cursor: "pointer" }}
                >
                  Sim
                </Button>
                <Button
                  fontSize={12}
                  width="50%"
                  bg="#4B4EFF"
                  onClick={onClose}
                  color="white"
                  _hover={{ bgColor: "#BABBFF", cursor: "pointer" }}
                >
                  Não
                </Button>
              </Flex>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
